<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";
import { adService } from "@/app/services/AdService";
import router from "@/router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { useRoute } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { DisplayDetail } from "@/types/ad/DisplayDetail";

const route = useRoute();
const loader = useLoader();
const errorModal = useErrorModal();

const ad = ref<DisplayDetail | null>(null);

const handleAdClickEvent = (event: Event) => {
  if (ad.value) {
    adService.handleAdClickEvent(event, ad.value.id);
  }
};

onMounted(async () => {
  try {
    loader.show();
    const adId = Number(route.params.adId);
    const displayDetail = await adService.displayDetail(adId);
    if (displayDetail) {
      ad.value = displayDetail;

      // 表示イベントを送信（await しない）
      adService.registerEvent(displayDetail.id, "view_detail");

      // 表示後のイベントを受信するためのリスナーを登録
      window.removeEventListener("click", handleAdClickEvent);
      window.addEventListener("click", handleAdClickEvent);
    }
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

onUnmounted(() => {
  window.removeEventListener("click", handleAdClickEvent);
});

function onClickBack() {
  router.back();
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      詳細
    </Header>
    <div v-if="ad">
      <div data-testid="detail-html" v-html="ad.html"></div>
    </div>
    <div v-else>
      <p class="empty">見つかりませんでした。</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.empty {
  margin-top: 40px;
  text-align: center;
}
</style>
